import * as React from "react";
import { MeditationPrescriptionItemRequest, PrescriptionItemGuideline } from "@curefit/gmf-common";
import {default as AppUtils, EpochConstants, LOADING_STATE} from "../../utils/AppUtils"
import EditViewCard, {EditViewDisplayMode} from "../../components/common/EditViewCard"
import AppLoader from "../../components/utils/AppLoader"
import * as _ from "lodash"
import ModelFactory from "../../models/ModelFactory"
import IEditedBy from "../../models/IEditedBy";
import {PatientMindfulnessPlansEditorProps} from "../../components/patient/edit/MindfulnessPlanEditor";
import {MindfulnessPlanViewProps} from "../../components/patient/view/MindfulnessPlanView";
import {AdherenceCategories, AppConstants} from "../../utils/AppConstants";
import IMeditationPrescription from "../../models/IMeditationPrescription";
import {IPlanActivity} from "../../models/LCPlanClientModels";

/**
 * Created by aditya on 28/02/18.
 */

export interface MindfulnessPlanEditViewContProps {
    editedBy: IEditedBy,
    patientId: number,
    secondaryPatientId: string,
    patientMindfulnessPlans: MeditationPrescriptionItemRequest[],
    displayMode?: EditViewDisplayMode,
    fetchPatientFitnessPlan?: (patientId: number) => any,
    savePatientFitnessPlan?: (patientId: number, patientFitnessPlans: MeditationPrescriptionItemRequest[]) => any
    fetchFitnessActivities?: (input: string) => Promise<any>;
    isSelf: boolean;
    consultationId: number;
    doctorId: number;
    doctorType: string;
    doctorName: string;
}

export interface MindfulnessPlanEditViewContState {
    savedMindfulnessPlans: {item: MeditationPrescriptionItemRequest}[],
    updatedMindfulnessPlans: {item: MeditationPrescriptionItemRequest}[],
    isPatientMindfulnessPlanDataLoaded: LOADING_STATE,
    updatedMindGuidelines: {item: PrescriptionItemGuideline}[],
    guidelinesItemId: string
}

class MindfulnessPlanEditViewCont extends React.Component<MindfulnessPlanEditViewContProps, MindfulnessPlanEditViewContState> {

    constructor(props: MindfulnessPlanEditViewContProps) {
        super(props);
        this.state = this.getStateFromProps(props);
    }

    componentWillReceiveProps(props: MindfulnessPlanEditViewContProps) {
        this.setState(this.getStateFromProps(props));
    }

    getUpdatedConcernsFromProps = (props: MindfulnessPlanEditViewContProps): {item: MeditationPrescriptionItemRequest}[] => {
        let currUpdatedConcerns: {item: MeditationPrescriptionItemRequest}[] = [];
        _.map(props.patientMindfulnessPlans, function(concern){
            let clonePatientConcern = Object.assign({}, concern);
            currUpdatedConcerns.push({item: clonePatientConcern});
        });
        return currUpdatedConcerns;
    }

    getStateFromProps = (props: MindfulnessPlanEditViewContProps) => {
        let currState: MindfulnessPlanEditViewContState = {
            savedMindfulnessPlans: [],
            updatedMindfulnessPlans: [],
            isPatientMindfulnessPlanDataLoaded: LOADING_STATE.NOT_INITIALIZED,
            updatedMindGuidelines: [],
            guidelinesItemId: null
        }
        if ( _.isNull(props.patientMindfulnessPlans) ) {
            props.fetchPatientFitnessPlan(this.props.patientId);
            currState.isPatientMindfulnessPlanDataLoaded = LOADING_STATE.LOADING;
        } else {
            currState.updatedMindfulnessPlans = [];
            if (!_.isEmpty(props.patientMindfulnessPlans)) {
                _.map(props.patientMindfulnessPlans, function(patientConcern){
                    let clonePatientConcerns = Object.assign({}, patientConcern);
                    if (patientConcern.onlyGuidelines) {
                        currState.guidelinesItemId = AppUtils.isDefined(patientConcern._id) ? patientConcern._id : null;
                        (clonePatientConcerns.guidelines || []).map((guideline: PrescriptionItemGuideline) => {
                            let clonedGuidelineItem = {...guideline};
                            currState.updatedMindGuidelines.push({item: clonedGuidelineItem})
                        });
                    } else {
                        if (_.isEmpty(patientConcern._id)) {
                            currState.updatedMindfulnessPlans.push({item: clonePatientConcerns});
                        } else {
                            currState.savedMindfulnessPlans.push({item: clonePatientConcerns});
                        }
                    }
                });
            }
            currState.isPatientMindfulnessPlanDataLoaded = LOADING_STATE.LOADED;
        }
        return currState;
    }

    getConcernEditViewTemplateProps = () => {
        let patientFitnessPlanViewProps: MindfulnessPlanViewProps = {
            patientMindfulnessPlans: this.props.patientMindfulnessPlans
        }
        let patientFitnessPlanEditorProps: PatientMindfulnessPlansEditorProps = {
            fetchFitnessActivities: this.props.fetchFitnessActivities,
            updatedMindfulnessPlans: this.state.updatedMindfulnessPlans,
            updateMindfulnessPlans: this.updatePatientFitnessPlan,
            savedMindfulnessPlans: this.state.savedMindfulnessPlans,
            updateSavedMindfulnessPlans: this.updateSavedMindfulnessPlans,
            updatedMindGuidelines: this.state.updatedMindGuidelines,
            updateMindPlanGuidelines: this.updateMindGuidelines,
            consultationId: this.props.consultationId,
            doctorId: this.props.doctorId,
            doctorType: this.props.doctorType,
            doctorName: this.props.doctorName
            // fetchStaticSymptomData: this.props.fetchPatientFitnessPlan
        }
        return {"view": patientFitnessPlanViewProps, "edit": patientFitnessPlanEditorProps};
    }

    updateSavedMindfulnessPlans = (savedMindfulnessPlans: {item: IMeditationPrescription}[]) => {
        this.setState({savedMindfulnessPlans});
    }

    updatePatientFitnessPlan = (updatedMindfulnessPlans: {item: MeditationPrescriptionItemRequest}[]) => {
        this.setState({updatedMindfulnessPlans});
    }

    updateMindGuidelines = (updatedMindGuidelines: { item: PrescriptionItemGuideline }[]) => {
        this.setState({ updatedMindGuidelines })
    }

    savePatientFitnessPlan = () => {
        let myInstance = this;
        let mindfulnessPrescription: MeditationPrescriptionItemRequest[] = this.getSaveObject();
        // if (ModelFactory.isValidMindfulnessPrescription(mindfulnessPrescription)) {
            this.setState({isPatientMindfulnessPlanDataLoaded: LOADING_STATE.NOT_INITIALIZED})
            this.props.savePatientFitnessPlan(this.props.patientId, mindfulnessPrescription).then(function(){
                myInstance.setState({isPatientMindfulnessPlanDataLoaded: LOADING_STATE.LOADED})
            });
        // }
    }

    cancelActionHandler = () => {
        this.setState({updatedMindfulnessPlans: this.getUpdatedConcernsFromProps(this.props)});
    }

    isFormDirty = (): boolean => {
        let status = false;
        let erronousRows: number[] = [];
        _.map(this.state.updatedMindfulnessPlans, function(updatedMindfulnessPlanItem: {item: IPlanActivity}, index: number){
            if (!ModelFactory.isValidFitnessPrescriptionItem(updatedMindfulnessPlanItem.item)) {
                status = true;
                erronousRows.push(index + 1);
                return false;
            }
        })
        return status;
    }

    dirtyFormText = (): string => {
        let erronousRows: any[] = [];
        _.map(this.state.updatedMindfulnessPlans, function(updatedMindfulnessPlanItem: {item: IPlanActivity}, index: number){
            if (!ModelFactory.isValidFitnessPrescriptionItem(updatedMindfulnessPlanItem.item)) {
                erronousRows.push({index: index + 1, erroneousCol: ModelFactory.getPlanActivityEmptyCol(updatedMindfulnessPlanItem.item)});
                return false;
            }
        })
        if (!_.isEmpty(erronousRows)) {
            const errorTexts: string[] = erronousRows.map((rowItem) => `${rowItem.erroneousCol} in row ${rowItem.index}`)
            let errorText = `Missing ${errorTexts.join(", ")}`;
            return errorText;
        }
        return null
    }

    getSaveObject = (): MeditationPrescriptionItemRequest[] => {
        let myInstance = this;
        let saveConcernsList: MeditationPrescriptionItemRequest[] = [];
        _.map(this.state.updatedMindfulnessPlans, function(updatedConcernItem: {item: MeditationPrescriptionItemRequest}){
            let updatedItem = updatedConcernItem.item;
            if (updatedItem.startEpoch === null) {
                updatedItem.startEpoch = new Date().getTime();
                updatedItem.endEpoch = new Date().getTime() + (EpochConstants.EPOCH_IN_AN_DAY * 90);
            }
            updatedItem.onlyGuidelines = false;
            updatedItem.status = AppConstants.planStatus.LIVE;
            updatedItem.secondaryUserId = myInstance.props.secondaryPatientId.toString();
            updatedItem.isSelf = myInstance.props.isSelf;
            saveConcernsList.push(updatedItem);
        });
        _.map(this.state.savedMindfulnessPlans, (updatedFitnessPrecriptionItem: {item: MeditationPrescriptionItemRequest}) => {
            let updatedItem = { ...updatedFitnessPrecriptionItem.item };
            saveConcernsList.push(updatedItem);
        });

        /* FOR GUIDELINES FITNESS PRESCRIPTION ITEM */
        let updatedGuidelinesList = this.state.updatedMindGuidelines.map((guideline: {item: PrescriptionItemGuideline}) => guideline.item);
        let updatedGuidelineItem = null;
        if (AppUtils.isDefined(this.state.guidelinesItemId)) {
            updatedGuidelineItem = this.props.patientMindfulnessPlans.find((planItem) => planItem._id === this.state.guidelinesItemId);
            updatedGuidelineItem.guidelines = updatedGuidelinesList
        } else if (!_.isEmpty(updatedGuidelinesList)) {
            updatedGuidelineItem = this._getUpdatedGuidlinesPrescriptionItem(updatedGuidelinesList);
        }

        if (AppUtils.isDefined(updatedGuidelineItem)) saveConcernsList.push(updatedGuidelineItem);
        return saveConcernsList;
    };

    _getUpdatedGuidlinesPrescriptionItem = (guidelinesList: PrescriptionItemGuideline[]) => {
        let updatedGuidelineItem = ModelFactory.createNewFitnessPlanPrescriptionItem(AdherenceCategories.MIND, guidelinesList);
        if (updatedGuidelineItem.startEpoch === null) {
            updatedGuidelineItem.startEpoch = new Date().getTime();
            updatedGuidelineItem.endEpoch = new Date().getTime() + (EpochConstants.EPOCH_IN_AN_DAY * 90);
        }
        updatedGuidelineItem.onlyGuidelines = true;
        updatedGuidelineItem.status = AppConstants.planStatus.LIVE;
        updatedGuidelineItem.secondaryUserId = this.props.secondaryPatientId.toString();
        updatedGuidelineItem.isSelf = this.props.isSelf;
        return updatedGuidelineItem;
    };

    render() {
        let isConcernDataLoaded =  this.state.isPatientMindfulnessPlanDataLoaded === LOADING_STATE.LOADED;
        return (
            <div className="fitness-plan-editview-cont">
                {
                    isConcernDataLoaded &&
                    <EditViewCard cardTitleDisplay={"Mindfulness Plan"} templateName={"mindfulnessPlan"}
                                  templateProps={this.getConcernEditViewTemplateProps()}
                                  lastEditedEpoch={new Date().getTime()} saveActionHandler={this.savePatientFitnessPlan}
                                  cancelActionHandler={this.cancelActionHandler}
                                  displayMode={this.props.displayMode}
                    />
                }
                {
                    !isConcernDataLoaded &&
                    <AppLoader/>
                }
            </div>
        );
    }
}

export default MindfulnessPlanEditViewCont